import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_LOCATION_TYPE_MUTATION } from '../graphql/mutations'
import { DELETE_LOCATION_TYPE } from '../redux/action-types'

const useDeleteLocationTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.locationTypes.locationTypesAndLocationTypeCategories,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_LOCATION_TYPE_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_LOCATION_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteLocationTypeMutation
